module.exports = __webpack_public_path__ + "static/media/10705238_813515371858_693663195_n.b496b18d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/makeup_hair/10705238_813515371858_693663195_n.jpg
// module id = 336
// module chunks = 0